// Module-level mirror of the Auth0 access token held in AuthContext.
//
// Non-React code paths (the SWR `basicFetcher`, WebSocket subprotocol lists)
// need the token without threading it through every call site. It is written
// by useAuthorization() each time a token is fetched or refreshed, before the
// React state update that re-renders the pages, so any fetch triggered by that
// render already sees it.
let accessToken: string | null = null

export function setStoredAccessToken (token: string | null): void {
  accessToken = token
}

export function getStoredAccessToken (): string | null {
  return accessToken
}
